import { render, staticRenderFns } from "./Stack.vue?vue&type=template&id=7d3d57aa&scoped=true"
import script from "./Stack.vue?vue&type=script&lang=js"
export * from "./Stack.vue?vue&type=script&lang=js"
import style0 from "./Stack.vue?vue&type=style&index=0&id=7d3d57aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3d57aa",
  null
  
)

export default component.exports